import { DesignSystem, ElementDesignSystem, ElementDesignSystemConfig } from "../DesignSystem";
import { DefaultWatermark } from "./DefaultWatermark/DefaultWatermark";

export interface WatermarkDesignSystemConfig extends Pick<ElementDesignSystemConfig, 'position' | 'animation'> {
    imageURL: string;
    opacity: number;
    scale: number;
    showWatermark: boolean;
}

export class WatermarkDesignSystem extends ElementDesignSystem implements WatermarkDesignSystemConfig {
    public imageURL: string;
    public opacity: number;
    public scale: number;
    public showWatermark: boolean;

    constructor(
        config: WatermarkDesignSystemConfig,
        designSystem: DesignSystem,
        inCloudRenderingEnvironment:boolean
    ) {
        super({ ...config, designSystem: designSystem, affectedBySafeZone: true, inCloudRenderingEnvironment});
        this.imageURL = config.imageURL;
        this.opacity = config.opacity;
        this.scale = config.scale;
        this.showWatermark  = config.showWatermark;
    }

    protected renderChild() {
        return (
            <DefaultWatermark {...this} />
        );
    }
}